import { startOfDay, addBusinessDays } from 'date-fns';
import { MIN_DAYS_BETWEEN_TICKET_FARE_VALID_FROM_AND_NOW } from '@/store/useShoppingCartStore';

export const getEarliestTicketFareValidFrom = (): Date => {
  const today = startOfDay(new Date());

  return addBusinessDays(today, MIN_DAYS_BETWEEN_TICKET_FARE_VALID_FROM_AND_NOW);
};
